export default {
    more: 'view more',
    less: 'view less',
    likeProduct: 'like product',
    removeButton: 'remove__button',
    removeProduct: 'remove product',
    noData: 'no data',
    minimumValueNotReached: 'minimum order value price is not reached',
    shieldIcon: 'Icon shield for secure payment',
    searchIcon: 'search icon',
    noFaqs: 'no faqs',
    sliderImage: 'slider image',
    collapseSubcategories: 'collapse subcategories',
    notifications: 'notifications',
    orders: 'orders',
    wishList: 'wish list',
    cart: 'cart',
    avatar: 'avatar',
    arrowAvatar: 'arrow avatar',
    avatarInactive: 'avatar-inactive',
    avatarActive: 'avatar-active',
    stores: 'stores',
    settings: 'settings',
    help: 'help',
    logout: 'logout',
    editDeliveryInformation: 'edit delivery information',
    checkmark: 'checkmark',
    orderConfirmed: 'order confirmed',
    onDelivery: 'on delivery',
    addNewAddress: 'add new address',
    chooseNewAddress: 'choose new address',
    addToCart: 'add to cart',
    reviewStar: 'review star',
    resetFilters: 'reset filters',
    noReviews: 'no reviews',
    arrowLeft: 'arrow left',
    arrowRight: 'arrow right',
    arrowUp: 'arrow up',
    arrowDown: 'arrow down',
    cancel: 'cancel',
    cardView: 'card view',
    delete: 'delete',
    noFavourites: 'no favourites',
    edit: 'edit',
    show: 'show',
    hide: 'hide',
    selectPhoneNumber: 'Select phone number',
    resendCode: 'resend code',
    recoveryCodes: 'recovery codes',
    verified: 'verified',
    authentificationAppIcon: 'Authentification app icon',
    qrCode: 'Qr code',
    protectAccountIcon: 'protect account icon',
    desktop: 'desktop',
    mobile: 'mobile',
    tablet: 'tablet',
    dots: 'dots',
    previousProduct: 'previous product',
    nextProduct: 'next product',
    comment: 'comment',
    user: 'user',
    product: 'product',
    noNotifications: 'no notifications',
    close: 'close',
    message: 'message',
    categories: 'categories',
    bill: 'bill'
}
